export interface ITiragemProdutoConfig {
  minimoCartela: number
  meiaCartela?: number // tamanho do múltiplo (ex: 500 para copos)
}

const STORAGE_KEY = 'hcp_tiragem_config_v2'
export const TIRAGEM_MINIMA_PADRAO = 2000

export function getConfig(): Record<string, ITiragemProdutoConfig> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : {}
  } catch {
    return {}
  }
}

export function saveConfig(config: Record<string, ITiragemProdutoConfig>): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(config))
}

export function getProdutoConfig(
  produto_nome: string,
  config?: Record<string, ITiragemProdutoConfig>
): ITiragemProdutoConfig {
  const c = config ?? getConfig()
  return c[produto_nome] ?? { minimoCartela: TIRAGEM_MINIMA_PADRAO }
}
